module.exports = __webpack_public_path__ + "img/h_1_js.e2252cf6.png";